import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProductDiscontinued',
    props: {
        replacement: { default: null }
    },
    setup(__props) {
        const props = __props;
        const url = computed(() => `/diy-framing/accessories/${props.replacement?.category?.type?.slug}/${props.replacement?.meta?.slug}`);
        return { __sfc: true, props, url, computed };
    }
});
